/* eslint-disable eqeqeq */
import React from "react";
import { useNavigate } from "react-router";
import { ModalComp } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { DeleteUserData, resetDeleteSlice } from "../../redux/Slice/Users/DeleteUserSlice";
import { AllUsersList } from "../../redux/Slice/Users/UserListSlice";
import { toast } from "react-toastify";

const ArchiveUser = ({ archive, setArchive, id }: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const { status, message } = useAppSelector(state => state.deleteUser)
  const [isDeleting, setIsDeleting] = React.useState(false)

  const handleDelete = () => {
    if (isDeleting) return
    setIsDeleting(true)
    dispatch(DeleteUserData(id))
  }

  if (status == "200") {
    setIsDeleting(false)
    setArchive(false)
    navigate("/users")
    dispatch(AllUsersList())
    dispatch(resetDeleteSlice());
  } else {
    if (message) {
      setIsDeleting(false)
      toast.error(message)
      setArchive(false)
      dispatch(resetDeleteSlice())
    }
  }

  return (
    <ModalComp archive={archive} setArchive={setArchive} handleDelete={handleDelete} isDeleting={isDeleting} />
  );
};

export { ArchiveUser };
